// Rows of a list matching a search: one of their values (values(row) → array) contains the text, whatever the case.
export const searchRows = (rows, query, values) => {
  const text = String(query || "").trim().toLowerCase();
  if (!text) return rows || [];
  return (rows || []).filter((row) =>
    values(row).some((value) => value !== null && value !== undefined && String(value).toLowerCase().includes(text)),
  );
};
